import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DownloadFileSvg = function DownloadFileSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.265 13.915-1.96-1.976-1.039 1.048L12 16.75l3.734-3.764-1.04-1.048-1.96 1.976V8.297h-1.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2h12.978L21 7.064V22H3zm1.47 1.481v17.037h15.06V7.679L15.37 3.48z",
    clipRule: "evenodd"
  }));
};
export var DownloadFile = function DownloadFile(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DownloadFileSvg
  }));
};